export const CREATE_REPORTS_SELECTED_COLUMNS = {
  ticketsReport: {
    defaultChecked: [
      'event_start_time',
      'created_at',
      'id',
      'ticket_id',
      'start_stamp',
      'email',
      'name',
      'option_name',
      'ticket_state',
      'state',
      'listing_title',
      'listing_url'
    ]
  },
  addOnsReport: {
    defaultChecked: [
      'created_at',
      'id',
      'ticket_id',
      'event_start_time',
      'email',
      'name',
      'option_name',
      'sku',
      'listing_title',
      'ticket_state',
      'state'
    ]
  },
  ordersReport: {
    defaultChecked: [
      'state',
      'num_add_ons',
      'ticket_state',
      'created_at',
      'id',
      'event_start_time',
      'buyer_email',
      'host_purchased_by_email',
      'quantity',
      'add_on_types',
      'ticket_types',
      'option_types',
      'title',
      'listing_url'
    ]
  },
  attendeesReport: {
    defaultChecked: [
      'created_at',
      'start_stamp',
      'id',
      'name',
      'first_name',
      'last_name',
      'email',
      'ticket_state',
      'state',
      'scan_ins',
      'manual_check_ins',
      'total_check_ins',
      'max_redemptions',
      'check_outs',
      'buyer_name',
      'ticket_id'
    ]
  }
};



// WEBPACK FOOTER //
// ./src/constants/create-reports-selected-columns.js